import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { toastConfig } from 'assets/data/config';
import { useSelector } from 'react-redux';
import { MicrosoftTemplate } from 'types/template';

export const keys = {
  microsoftTemplates: 'microsoftTemplates',
};

interface TeamTemplateResponse {
  name: string;
  id: string;
}

export const useFetchMicrosoftTemplates = () => {
  const tenantId = useSelector((state: any) => state.app.tenantId);

  return useQuery<MicrosoftTemplate[]>({
    queryKey: [keys.microsoftTemplates, tenantId],
    queryFn: async () => {
      const response = await axios(config.apiGateway.teamTemplateIds, {
        method: 'POST',
        data: {
          tenantId,
        },
      });

      if (
        response.data?.message &&
        response.data.message === 'No template found'
      ) {
        toast.error('No Teams Saved Templates Found', toastConfig);
        return [];
      }

      if (response?.data && response.data.length > 0) {
        return response.data.map((template: TeamTemplateResponse) => ({
          label: template.name,
          value: template.id,
        }));
      }

      return [];
    },
    enabled: !!tenantId,
  });
};
